<template lang="pug">
    div
        v-card-text
            v-select.title#payment-method(label="Seleccione forma de pago"
                    :items="filteredPaymentMethodsList"
                    item-text="text"
                    item-value="id"
                    v-model="paymentMethod"
                    @input="clearPayment"
                    @keydown.enter="focusPaymentMethod"
                    )
        
        v-card-text(v-if="payMethSelected")
            div(v-if="paymentMethod===1")
                cash-payment(@confirm="addPayment")
            div(v-if="paymentMethod===2")
                transbank-payment(
                    @confirm="addPayment"
                    )
            div(v-if="paymentMethod===3")
                transbank-payment
            div(v-if="paymentMethod===4")
                check-payment
            div(v-if="paymentMethod===7")
                bank-document-payment(@confirm="addPayment")
            div(v-if="paymentMethod === 8")
                credit-note-payment(
                    :saleCreditNotes='saleCreditNotes' 
                )
            v-divider
        v-card-actions
            v-spacer
            v-btn.white--text.body-1.font-weight-light#add-payment-button(color="green darken-1" round
                @click='addPayment' @keyup.enter='addPayment'
                :disabled="!allDataSet") Confirmar pago
</template>

<script>
/* compontents */
import CashPayment from './CashPayment'
import TransbankPayment from './TransbankPayment'
import CheckPayment from './CheckPayment'
import BankDocumentPayment from './BankDocumentPayment'
import CreditNotePayment from './CreditNotePayment'
/* vuex */
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
    name: 'payment-method',
    props: {
        saleCreditNotes: {
            type: Array,
            default: () => [],
        }
    },
    data: function() {
        return {
            paymentMethod: null,
        }
    },
    computed: {
        payMethSelected() {
            return this.paymentMethod !== ''
        },
        ...mapState('CustomerPaymentModule', {
            paymentMethodsList: 'paymentMethodsList',
            paymentMethod: 'paymentMethod',
            arrayPayments: 'arrayPayments',
        }),
        ...mapGetters('CustomerPaymentModule', {
            //change: '//',
            //totalToPay: 'totalToPay',
            //totalPaid: 'totalPaid',
            allDataSet: 'allDataSet',
        }),
        filteredPaymentMethodsList() {
            return this.paymentMethodsList.filter(
                m =>
                    [2, 3].includes(m.id)
                        ? !this.arrayPayments.find(p =>
                              [2, 3].includes(p.paymentMethod)
                          )
                        : true
            )
        },
    },
    methods: {
        ...mapActions('CustomerPaymentModule', {
            //resetCashDeskState: 'resetCashDeskState',
            //submitSale: 'submitSale',
            clearPayment: 'clearPayment',
            savePayment: 'savePayment',
            setPaymentMethod: 'setPaymentMethod',
        }),
        /**
         *
         */
        addPayment() {
            this.savePayment()
            this.paymentMethod = ''
            setTimeout(
                () => document.getElementById('payment-method').focus(),
                200
            )
        },
        focusPaymentMethod() {
            if (this.paymentMethod === 1)
                this.$nextTick(() =>
                    document.getElementById('cash-pay-input').focus()
                )
            if ([2, 3].includes(this.paymentMethod)) {
                console.log('asdfasdf')
                this.$nextTick(() =>
                    document.getElementById('transbank-pay-input').focus()
                )
            }
        },
    },
    watch: {
        paymentMethod: function(newVal, oldVal) {
            this.setPaymentMethod(newVal)
        },
    },
    components: {
        'cash-payment': CashPayment,
        'transbank-payment': TransbankPayment,
        'check-payment': CheckPayment,
        'bank-document-payment': BankDocumentPayment,
        'credit-note-payment': CreditNotePayment,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        //this.setPaymentMethod(1)
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
